const storageKey = (userId: number) => `po:selectedPair:${userId}`;

/** Пара per tab (sessionStorage); ключ с user_id — смена аккаунта не подтягивает чужую пару. */
export const getStoredPair = (userId: number): string | null => {
  if (typeof window === "undefined") return null;
  return sessionStorage.getItem(storageKey(userId));
};

export const setStoredPair = (userId: number, symbol: string): void => {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(storageKey(userId), symbol);
};

export const clearStoredPair = (userId: number): void => {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(storageKey(userId));
};
